export default [
  {
    title: 'Verlonen',
    icon: 'BriefcaseIcon',
    action: 'read',
    resource: 'payslips',
    children: [
      {
        title: 'Loonstroken',
        route: 'app-payslips',
        icon: 'FileTextIcon',
        action: 'read',
        resource: 'payslips',
      },
      {
        title: 'Uitbetalingen',
        route: 'app-payout-payments',
        icon: 'SlidersIcon',
        action: 'read',
        resource: 'payslips-options',
      },
    ],
  },
]
